import React, {useCallback, useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import * as my from './MyForm'

export function isCheckBoxEnabled(value){
	return value === true
	|| value === 'true'
	|| parseInt(value) === 1
}

export const CheckboxOld = ({
							 inputRef = false,
							 inline = false,
							 label = 'Label',
							 options = [
								 // {value: 0, name: 'checkbox1', label: 'Option 1'},
								 // {value: 1, name: 'checkbox1', label: 'Option 2'}
							 ],
							 // defaultValue = [], //active options
							 hint = '',
							 errorMessage = '',
							 validMessage = '',
							 className = '',
						 }) => {
	// options = useMemo(()=>{
	//     if(options && options.length > 0){
	//         options = options.map((option)=>{
	//             option.value = option.name && defaultValue && defaultValue.length > 0 && (
	//                 defaultValue.includes(option.name)
	//                 || defaultValue.includes(option.name.match(/\[(\w+)\]/)[1])
	//             ) ? true : option.value;
	//             return option;
	//         })
	//     }
	//     return options;
	// }, [options, defaultValue]);

	return (
		<div className={`form-element ${inline ? 'form-element-inline' : ''} ${className}`}>
			<div className="form-label">{label}</div>
			<div className="flex items-center justify-start space-x-2">
				{options.map((option, i) => (
					<div className="inline-flex items-center space-x-2" key={i}>
						<input
							key={option.name+'_'+option.value}
							ref={inputRef}
							type="checkbox"
							defaultChecked={option.value}
							id={i+'_'+option.name}
							name={option.name}
							className={`form-checkbox text-blue-500 h-4 w-4 ${
								// errorMessage ? 'border-red-500' : ''
								errorMessage ? ' form-checkbox-invalid text-red-500 ' : ''
								+ validMessage ? ' form-checkbox-valid text-green-500' : ''
							}`}
						/>
						<label htmlFor={i+'_'+option.name} className={` ${
							errorMessage ? ' text-red-500 ' : ''
							+ validMessage ? ' text-green-500' : ''
						}`}>{option.label}</label>
					</div>
				))}
			</div>
			{errorMessage && (
				<div className="form-error">{errorMessage}</div>
			)}
			{validMessage && (
				<div className="form-success">{validMessage}</div>
			)}
			{hint && (<div className="form-hint">{hint}</div>)}
		</div>
	)
}
CheckboxOld.propTypes = {
	inline: PropTypes.bool,
	label: PropTypes.string,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.any,
			name: PropTypes.string,
			label: PropTypes.string
		})
	),
	hint: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	errorMessage: PropTypes.string,
	validMessage: PropTypes.string
}

const CheckIcon = () => <>
	{/* <my.CheckIcon data-check-icon data-interminate>
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect x="0.5" y="0.5" width="15" height="15" fill="#32A0E5"/>
			<rect x="0.5" y="0.5" width="15" height="15" stroke="#32A0E5"/>
			<path fill-rule="evenodd" clip-rule="evenodd" d="M12 8.5H4V7.5H12V8.5Z" fill="white"/>
		</svg>
	</my.CheckIcon> */}
	<my.CheckIcon data-check-icon data-checked data-hover>
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect x="0.5" y="0.5" width="15" height="15" fill="#32A0E5"/>
			<rect x="0.5" y="0.5" width="15" height="15" stroke="#32A0E5"/>
			<path d="M6.90576 10.6666L3.39136 7.15223L3.85528 6.68829L6.90576 9.73835L12.1445 4.5L12.6085 4.96392L6.90576 10.6666Z" fill="white"/>
		</svg>
	</my.CheckIcon>
	<my.CheckIcon data-check-icon data-checked>
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect x="0.5" y="0.5" width="15" height="15" fill="#32A0E5"/>
			<rect x="0.5" y="0.5" width="15" height="15" stroke="#32A0E5"/>
			<path d="M6.90576 10.6666L3.39136 7.15223L3.85528 6.68829L6.90576 9.73835L12.1445 4.5L12.6085 4.96392L6.90576 10.6666Z" fill="white"/>
		</svg>
	</my.CheckIcon>
	<my.CheckIcon data-check-icon data-hover>
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="16" height="16" fill="#32A0E5" fillOpacity="0.1"/>
			<rect x="0.5" y="0.5" width="15" height="15" stroke="#32A0E5" strokeOpacity="0.2"/>
		</svg>
	</my.CheckIcon>
	<my.CheckIcon data-check-icon >
		<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect width="16" height="16" fillOpacity="0.03"/>
			<rect x="0.5" y="0.5" width="15" height="15" stroke="#32A0E5" strokeOpacity="0.2"/>
		</svg>
	</my.CheckIcon>
</>

export const Checkbox = ({
	inputRef = undefined,
	inline = false,
	label = 'Label',
	name = '',
	defaultValue = false,
	hint = '',
	errorMessage = '',
	validMessage = '',
	className = '',
  fullWidthSelection = false,
	...rest
}) => {
	const [value, setValue] = useState(!!defaultValue);

	const _onChange = useCallback((e)=>{
		rest.onChange && rest.onChange(e, e.target.checked);
		setValue(e.target.checked)
	}, [])

	useEffect(()=>{
		setValue(!!defaultValue)
	}, [defaultValue])

	const id = `chkbox_${name}`
	const key = `${name}-${value}`
	return (
		<my.Elemet data-inline={!!inline}
							 data-full-width-selection={!!fullWidthSelection}
							 className={className}
		>
			<my.CheckElement data-check-elemet
											 data-full-width-selection={!!fullWidthSelection}
											 className="space-x-2"
			>
				<my.Check
					{...rest}
					ref={inputRef}
					data-inline={!!inline}
					data-invalid={!!errorMessage}
					data-valid={!!validMessage}
					defaultChecked={value}
					id={id}
					key={key}
					name={name}
					type="checkbox"
					onChange={_onChange}
					className={`form-checkbox`}
				/>
				<my.Label data-invalid={!!errorMessage}
									data-valid={!!validMessage}
									data-check
									data-full-width-selection={!!fullWidthSelection}
									htmlFor={id}
				>
					<CheckIcon />
					{label}
				</my.Label>
			</my.CheckElement>
			{!!errorMessage && (<my.Error data-inline={!!inline}>{errorMessage}</my.Error>)}
			{!!validMessage && (<my.Success data-inline={!!inline}>{validMessage}</my.Success>)}
			{
				!!hint && (
					typeof hint === 'string' 
						? <my.Hint data-inline={!!inline} dangerouslySetInnerHTML={{__html: hint}} className="ml-6" />
						: <my.Hint data-inline={!!inline} className="ml-6">{hint}</my.Hint>
				)
			}
		</my.Elemet>
	)
}
Checkbox.propTypes = {
	inline: PropTypes.bool,
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	defaultValue: PropTypes.any,
	hint: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	errorMessage: PropTypes.string,
	validMessage: PropTypes.string
}

